import { useAuth } from "@/auth/use-auth";
import { FeedbackForm } from "./feedback-form";

export function HelpArea() {
  const { authUser } = useAuth();
  if (!authUser) return null;

  return (
    <div className="fixed bottom-8 -right-1 z-40 h-28 translate-x-0 transition-transform duration-300 ease-out rounded-l-lg shadow-lg bg-secondary flex items-center cursor-pointer pointer-events-auto hover:-translate-x-1">
      <FeedbackForm
        trigger={
          <button className="[writing-mode:vertical-lr] h-full flex justify-center p-1 transform rotate-180 bg-primary rounded-r-lg text-white select-none">
            Need help?
          </button>
        }
      />
    </div>
  );
}
